import crop_list from "./crop_list";

const plot_manager = {
        title: String("Plots"),
        plotsManagerTitle: String("Details of the plot, {plot_name}"),
        plotsManagerNewPlotTitle: String("Create new plot"),
        askForPlotSelectorTitle: String("Select a plot or create a new"),
        paramsCropTitle: String("Crop parameters"),
        paramsIrrigationTitle: String("Irrigation parameters"),
        paramsSoilTitle: String("Soil parameters"),
        paramsTemperatureTitle: String("Temperature parameters"),
        profileNavButton: String("Profile"),
        paramsNavButton: String("Parameters"),
        modulesNavButton: String("Seasons"),
        askForTerrainSelectorDisabled: String("Select a farm ..."),
        plotName: String("Name of the plot"),
        plotNameInfoPopover: String("In this field you can put the name you want to use to refer to this plot."),
        plotNamePlaceholder: String("Name of the plot ..."),
        plotArea: String("Plot surface (ha)"),
        plotAreaInfoPopover: String("Surface of the plot in hectares"),
        plotCropArea: String("Total crop area (ha)"),
        plotCropAreaInfoPopover: String("Total crop area within the plot in hectares"),
        plotAssociatedTerrain: String("Associated farm"),
        plotAssociatedTerrainInfoPopover: String("Each plot belongs to a farm.Select a drop -down farm.In case of not having any, one creates one from the farm management section."),
        plotSigpacCode: String("SIGPAC Code"),
        plotSigpacCodeInfoPopover: String("SIGPAC Code"),
        paramsCropType: String("Type of crop"),
        paramsCropTypeInfoPopover: String("Type of crop"),
        paramsCropTypePlaceholder: String("crop..."),
        paramsCropPlantationAge: String("Age"),
        paramsCropPlantationAgeInfoPopover: String("Age of the plantation in years"),
        paramsCropPlantationAgePlaceholder: String("1"),
        paramsCropVariety: String("Variety"),
        paramsCropVarietyInfoPopover: String("Variety of crop"),
        paramsCropVarietyPlaceholder: String("variety..."),
        paramsCropVarietyType: String("Type of variety"),
        paramsCropVarietyTypeInfoPopover: String("Depending on the behavior of the variety and the period that covers its phenological cycle, it can be characterized as more or less early or late."),
        paramsCropVarietyTypePlaceholder: String("guy..."),
        paramsCropTreeDistance: String("Distance between trees (cm)"),
        paramsCropTreeDistanceInfoPopover: String("Distance in centimeters between the trees"),
        paramsCropRowDistance: String("Distance between rows (cm)"),
        paramsCropRowDistanceInfoPopover: String("Distance in centimeters between trees rows"),
        paramsCropCrownDiameter: String("Crown diameter (cm)"),
        paramsCropCrownDiameterInfoPopover: String("Diameter in centimeters of the crown of the trees"),
        paramsCropCupHeight: String("Cup height (cm)"),
        paramsCropCupHeightInfoPopover: String("Height in centimeters to the Tree Cup"),
        paramsCropVisibleRootDepth: String("Depth roots (cm)"),
        paramsCropVisibleRootDepthInfoPopover: String("Depth of visible roots"),
        paramsCropCoveredPresence: String("Cover presence"),
        paramsCropCoveredPresenceInfoPopover: String("If the crop has a cover presence"),
        paramsCropCoefficient: String("Cultivation coefficient"),
        paramsCropCoefficientInfoPopover: String("Cultivation coefficient"),
        paramsCropDevelopmentCoefficient: String("Crop development coefficient"),
        paramsCropDevelopmentCoefficientInfoPopover: String("Crop development coefficient"),
        paramsIrrigationSystem: String("Irrigation system"),
        paramsIrrigationSystemInfoPopover: String("Irrigation system"),
        paramsIrrigationSystemPlaceholder: String("Irrigation system..."),
        paramsDropperType: String("Type of dropper"),
        paramsDropperTypeInfoPopover: String("Type of dropper used in irrigation"),
        paramsDropperTypePlaceholder: String("Type of dripping ..."),
        paramsDropperFlow: String("Dropper (l/h)"),
        paramsDropperFlowInfoPopover: String("Flower's flow in liters per hour (l/h)"),
        paramsDroppersPerTree: String("Tree dripping"),
        paramsDroppersPerTreeInfoPopover: String("Number of drippers for each tree"),
        paramsDroppersDistance: String("Distance between Goteros (CM)"),
        paramsDroppersDistanceInfoPopover: String("Distance in centimeters between the drippers"),
        paramsApplicationEfficiency: String("Application efficiency"),
        paramsApplicationEfficiencyInfoPopover: String("Application efficiency"),
        paramsSoilUniformityCoefficient: String("Uniformity coefficient"),
        paramsSoilUniformityCoefficientInfoPopover: String("Uniformity coefficient"),
        paramsSoilOrganicMaterial: String("Organic Material (%)"),
        paramsSoilOrganicMaterialInfoPopover: String("Percentage of organic material containing the soil"),
        paramsSoilClayPercentage: String("Clay (%)"),
        paramsSoilClayPercentageInfoPopover: String("Percentage of clay containing the soil"),
        paramsSoilLimePercentage: String("Silt (%)"),
        paramsSoilLimePercentageInfoPopover: String("Percentage of silt containing the ground"),
        paramsSoilSandPercentage: String("Sand (%)"),
        paramsSoilSandPercentageInfoPopover: String("Percentage of sand containing the ground"),
        paramsSoilSoilTexture: String("Soil texture"),
        paramsSoilSoilTextureInfoPopover: String("Soil texture"),
        paramsSoilSoilTexturePlaceholder: String("Texture..."),
        paramsSoilTextureType: String("Type of texture"),
        paramsSoilTextureTypeInfoPopover: String("Type of soil texture"),
        paramsSoilTextureTypePlaceholder: String("Guy..."),
        paramsTemperatureMax: String("Maximum temperature (ºC)"),
        paramsTemperatureMaxInfoPopover: String("The maximum allowed temperature."),
        paramsTemperatureMin: String("Minimum temperature (ºC)"),
        paramsTemperatureMinInfoPopover: String("The minimum allowed temperature"),
        paramsTemperatureKTCoefficient: String("KT coefficient"),
        paramsTemperatureKTCoefficientInfoPopover: String("KT coefficient"),
        paramsTemperatureExtraterrestrialSolarRadiation: String("Extraterrestrial solar radiation"),
        paramsTemperatureExtraterrestrialSolarRadiationInfoPopover: String("Extraterrestrial solar radiation based on latitude"),
        month0: String("January"),
        month1: String("February"),
        month2: String("March"),
        month3: String("April"),
        month4: String("May"),
        month5: String("June"),
        month6: String("July"),
        month7: String("August"),
        month8: String("September"),
        month9: String("October"),
        month10: String("November"),
        month11: String("December"),
        plotModuleAddNew: String("Add new station"),
        plotModuleNameHeader: String("Station name"),
        plotModuleActionHeader: String("Actions"),
        plotModuleTypeHeader: String("Type of station"),
        plotModuleEnabledHeader: String("State"),
        plotModuleInstallationDateHeader: String("Instalation date"),
        plotModuleActionModify: String("Modify station"),
        plotModulesNoModuleInList: String("This plot does not contain any station."),
        plotNewPlotButton: String("Create new plot"),
        plotUpdate: String("Update plot data"),
        plotRestore: String("Restore all fields"),
        clayey: String("Clayey"),
        claySandy: String("Clay-sandy"),
        claySilty: String("Clay-limosa"),
        claySiltyLoam: String("Clay-Limosa Franco"),
        clayerLoam: String("Franco-Arcillosa"),
        sandyClayLoam: String("Clay-sandy Franco"),
        loamy: String("Frank"),
        siltyLoam: String("Franco-Limosa"),
        silty: String("Smosa"),
        sandyLoam1: String("Franco-Arenosa"),
        sandyLoam2: String("Franco-Arenosa"),
        loamySandy: String("ARENO-FRANCA"),
        sandy: String("Sandy"),
        noTextureType: String("Guy..."),
        fine: String("Fine"),
        average: String("Half"),
        thick: String("Fat woman"),
        grooves: String("Grooves"),
        beams: String("BRANCHES"),
        lying: String("Lying"),
        sprinkling: String("Aspersion"),
        located: String("Located"),
        dropper: String("Gotero"),
        microtube: String("Microtubo"),
        integrated: String("Integrated"),
        selfCompensated: String("Self -registered"),
        cropVariety_early: String("Early"),
        cropVariety_extraEarly: String("Extra-temple"),
        cropVariety_normal: String("Normal"),
        cropVariety_late: String("Late"),
        cropVariety_extraLate: String("Extra-tardia"),
        plotParamsNoExtraterrestrialSolarRadiation: String("A farm associated with the plot is required to determine extraterrestrial solar radiation."),
        errorFieldRequired: String("This field is required"),
        errorInvalidLength: String("This field requires a minimum of {length} characters"),
        errorNameAlreadyExists: String("This plot name already exists"),
        errorNegativeNumber: String("This field does not allow negative numbers"),
        minTemperatureError: String("The minimum temperature cannot be less than {temperature} ºC"),
        maxTemperatureError: String("The maximum temperature cannot be higher than {temperature} ºC"),
        errorsModalTitle: String("Errors in the plot"),
        errorsModalBodyTitle: String("It has not been possible to create/update the plot due to the following errors:"),
        errorsModalCloseButton: String("Close"),
        errorModalTemperatureParams: String("There is some error with temperature parameters."),
        errorModalCropParams: String("There is some error with crop parameters."),
        errorModalIrrigationParams: String("There is some error with irrigation parameters."),
        errorModalSoilParams: String("There is some error with soil parameters."),
        errorModalProfile: String("There is some error in the fields of the section: profile."),
};
plot_manager.crop_list = crop_list;

export default plot_manager;